import { IAccount } from "./account";
import { IServiceProvider } from "./service-provider";
import { ITenant } from "./tenant";

export interface IRole {
    id: number;
    name: string;
}

export interface IStatus {
    id: number;
    name: string;
}

export const ActiveStatus: IStatus = {
    id: 1,
    name: 'Active',
};
export const InactiveStatus: IStatus = {
    id: 2,
    name: 'Inactive',
};
export const PendingStatus: IStatus = {
    id: 3,
    name: 'Pending',
};



export interface IUser {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    photo: { path: string } | null;
    role: IRole | null;
    account: IAccount | null;
    serviceProvider: IServiceProvider | null;
    tenant: ITenant | null;
    status: IStatus;
    settings?: {
        telegram?: {
            chatId?: string | null;
        } | null;
    } | null;
}

export const SuperadminRole: IRole = {
    id: 0,
    name: 'Superadmin',
};

export const AdminRole: IRole = {
    id: 1,
    name: 'Admin',
};

export const UserRole: IRole = {
    id: 2,
    name: 'User',
};

export const ServiceRole: IRole = {
    id: 3,
    name: 'Service',
};

export const TunerRole: IRole = {
    id: 5,
    name: 'Tuner',
};